// extracted by css-extract-rspack-plugin
export default {"indexSortWrapper":"IndexSort-module__indexSortWrapper__c38bV"};